import { useState, useEffect, useRef } from "react";

const TimePicker = ({ t, label, selectedTime, setSelectedTime, timeOptions, loading, dependOn=false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [orderedOptions, setOrderedOptions] = useState(timeOptions);
  const [visibleCount, setVisibleCount] = useState(3);
  const dropdownRef = useRef(null);
  const textLoadingSlot=t("pages.booking_new.modal.text_loading_slots");
  const textNoSlot=t("pages.booking_new.modal.text_no_available_slot");

  const handleSelectTime = (time) => {
    setSelectedTime(time);
    setShowDropdown(false);

    setOrderedOptions((prevOptions) => {
      const newOptions = prevOptions.filter((t) => t !== time);
      return [time, ...newOptions];
    });
  };

  useEffect(() => {
    if (selectedTime && timeOptions.includes(selectedTime)) {
      setOrderedOptions([selectedTime, ...timeOptions.filter((t) => t !== selectedTime)]);
    } else {
      setOrderedOptions(timeOptions);
    }
  }, [selectedTime, timeOptions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    const updateVisibleCount = () => {
      const width = window.innerWidth;
      if (width < 400) { setVisibleCount(1) } 
      else if (width < 505) { setVisibleCount(2) } 
      else { setVisibleCount(3) }
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);

    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  return (
    <div className="time-picker-container">
      <p className="time-picker-label">{label}</p>
      <div className="time-options">
        {!loading ? (
          Array.isArray(orderedOptions) && orderedOptions.length > 0 ?
          <>
            {orderedOptions.slice(0, visibleCount).map((time) => (
              <button key={time} className={`time-button ${selectedTime === time ? "selected" : ""}`} onClick={() => handleSelectTime(time)}>
                {time}
              </button>
            ))}
  
            {orderedOptions.length > visibleCount && (
              <div className="dropdown-container" ref={dropdownRef}>
                <button className="time-button dropdown-button" onClick={() => setShowDropdown(!showDropdown)}>
                  {t("pages.booking_new.modal.more")} ⌵
                </button>
  
                {showDropdown && (
                  <div className="dropdown-menu">
                    {orderedOptions.slice(visibleCount).map((time) => (
                      <button key={time} className={`time-button ${selectedTime === time ? "selected" : ""}`} onClick={() => handleSelectTime(time)}>
                        {time}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
          </>
          :
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginLeft: '8px' }}><em>{!dependOn ? textNoSlot : '-'}</em></span>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {!dependOn ? 
              <>
                <div className="loading-spinner-small"></div>
                <span style={{ marginLeft: '8px' }}><em>{textLoadingSlot}</em></span>
              </>
              : 
              '-'
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default TimePicker;
